export default "__VITE_ASSET__BNWo9__8__"